"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.aetv = exports.lmc = exports.aliencon = exports.historycon = exports.historytalks = exports.lifetime = exports.fyi = exports.historyvault = exports.history = void 0;

var history = function history() {
  return {
    'Around the World': 'https://www.historychannel.tv',
    'History Education': 'https://www.history.com/classroom',
    'History Vault': 'https://www.historyvault.com?cmpid=HV_O_Site_H_Footer',
    'Mobile/Apps': 'https://www.history.com/apps',
    News: 'https://www.history.com/news',
    Shop: 'https://www.historystore.com/?utm_source=history&utm_medium=footer&utm_campaign=shop_link',
    'Share Your Opinion': 'https://www.historymakerscommunity.com/c/a/68tBwXMdFpqAVJU9Kkve18'
  };
};

exports.history = history;

var historyvault = function historyvault() {
  return {
    Documentaries: '/documentaries',
    Series: '/all-series',
    'Around the World': 'https://www.historychannel.tv',
    'Mobile/Apps': 'https://www.history.com/apps',
    News: 'https://www.history.com/news'
  };
};

exports.historyvault = historyvault;

var fyi = function fyi() {
  return {
    'Access FYI Videos': 'https://www.fyi.tv/full-access',
    'FYI App': 'https://www.fyi.tv/apps'
  };
};

exports.fyi = fyi;

var lifetime = function lifetime() {
  return {
    'Broad Focus': 'https://broadfocus.tumblr.com/',
    'Lifetime Apps': 'https://www.mylifetime.com/apps',
    'Lifetime Movie Club': 'https://www.lifetimemovieclub.com?cmpid=LMC_O_Site_LT_Footer',
    Outreach: 'https://www.mylifetime.com/my-lifetime-commitment',
    'Press Room': 'https://press.aenetworks.com/?ReturnUrl=%252fDefault.aspx',
    'Spanish/SAP': 'https://www.mylifetime.com/spanish-sap-schedule',
    'Share Your Opinion': 'https://www.lifetimeloyals.com/c/a/6EchUoQCenKEurg6XH6wEA'
  };
};

exports.lifetime = lifetime;

var historytalks = function historytalks() {
  return {
    FAQ: "https://history-talks.zendesk.com/hc/en-us/sections/360005724014-FAQ",
    Partners: "/partners/",
    'Contact Us': "/contact/",
    'Code of Conduct': "https://www.aenetworks.com/code-of-conduct-historytalks",
    'Terms of Use': "https://www.aenetworks.com/terms-of-use-historytalks",
    'Privacy Notice': "https://www.aenetworks.com/privacy-historytalks",
    'Cookie Notice': 'https://www.aenetworks.com/cookie-notice-historytalks',
    'Do Not Sell My Personal Information': 'https://forms.dsr-communications.com/custom/70328B73-2FB9-4426-9342-1C0D06F2EBC9'
  };
};

exports.historytalks = historytalks;

var historycon = function historycon() {
  return {
    FAQ: "https://historycon.zendesk.com/hc/en-us/sections/360005723974-FAQ",
    Partners: "/partners/",
    'Contact Us': "/contact/",
    Volunteers: "/volunteers/",
    Vendors: "/vendors/",
    'Code of Conduct': "https://www.aenetworks.com/code-of-conduct-historycon",
    'Terms of Use': "https://www.aenetworks.com/terms-of-use-historycon",
    'Privacy Notice': "https://www.aenetworks.com/privacy-historycon",
    'Cookie Notice': 'https://www.aenetworks.com/cookie-notice-historycon',
    'Do Not Sell My Personal Information': 'https://forms.dsr-communications.com/custom/70328B73-2FB9-4426-9342-1C0D06F2EBC9'
  };
};

exports.historycon = historycon;

var aliencon = function aliencon() {
  return {
    FAQ: 'https://www.aenetworks.com/aliencon-faq',
    Partners: '',
    'Contact Us': '/contact/',
    Volunteers: '',
    Vendors: '',
    'Code of Conduct': '',
    'Terms of Use': 'https://www.aenetworks.com/terms',
    'Privacy Notice': 'https://www.aenetworks.com/privacy-aliencon',
    'Cookie Notice': 'https://www.aenetworks.com/cookie-notice-aliencon',
    'Do Not Sell My Personal Information': 'https://forms.dsr-communications.com/custom/70328B73-2FB9-4426-9342-1C0D06F2EBC9'
  };
};

exports.aliencon = aliencon;

var lmc = function lmc() {
  return {
    'Broad Focus': 'https://broadfocus.tumblr.com/',
    'Lifetime Apps': 'https://www.mylifetime.com/apps',
    'Lifetime Movie Club': 'https://www.lifetimemovieclub.com?cmpid=LMC_O_Site_LT_Footer',
    Outreach: 'https://www.mylifetime.com/my-lifetime-commitment',
    'Press Room': 'https://press.aenetworks.com/?ReturnUrl=%252fDefault.aspx',
    'Spanish/SAP': 'https://www.mylifetime.com/spanish-sap-schedule'
  };
};

exports.lmc = lmc;

var aetv = function aetv() {
  return {
    'A&E Channel Apps': 'https://www.aetv.com/apps',
    'Email Updates': 'https://www.aetv.com/emails/sign-up',
    News: 'https://www.aetv.com/news',
    'Share Your Opinion': 'https://www.aetvaccess.com/c/a/6POtTmFst3u89ualzVVwtk'
  };
};

exports.aetv = aetv;